import { render, staticRenderFns } from "./TinyEditor.vue?vue&type=template&id=70c03bad"
import script from "./TinyEditor.ts?vue&type=script&lang=ts&external"
export * from "./TinyEditor.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports